(function ($) {
    $(document).ready(function () {
        $(".blog-grid-filter .outer-wrap .nav-wrapper .table-title").click(function () {
            if ($(this).parent().hasClass("active")) {
                $(this).parent().removeClass("active");
                $(this).parent().find(".list").slideUp();

            } else {
                $(".nav-wrapper").removeClass("active");
                $(".nav-wrapper").find(".list").slideUp();
                $(this).parent().addClass("active");
                $(this).parent().find(".list").slideDown();
            }
        });
        //document click will close the dropdown

        $(document).on("click", function (e) {
            var container = $(".blog-grid-filter .outer-wrap .nav-wrapper");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $(".blog-grid-filter .outer-wrap .nav-wrapper").removeClass("active");
                $('.blog-grid-filter .outer-wrap .nav-wrapper .list').slideUp();
            }
        });
        $(".blog-grid-filter .full-card .col .wrap-content .inner-wrap p").dotdotdot({
            height: 92,
            fallbackToLetter: true,
            watch: true,
        });
        $(".blog-grid-filter .full-card .col .item .card-wrap .card-intro p").dotdotdot({
            height: 150,
            fallbackToLetter: true,
            watch: true,
        });
    });
})(jQuery);

